class CollectionVariantSelects extends VariantSelects {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  updateURL() {
    if (!this.currentVariant) return;
    let newURL = `${this.dataset.url}?variant=${this.currentVariant.id}`;
    this.parentElement.parentElement.parentElement.href = newURL;
  }

  updateMedia() {
    const prodData = this.getProductData();
    const prodMedia = prodData.media;
    var varMedia = [];

    //loop all media to find ones with alt text that matches the colour
    const currentVariant = this.currentVariant;
    prodMedia.forEach(function (ele) {
      if (varMedia.length < 2) {

        let elAlt = ele.alt;
        if (elAlt) {
          if (ele.alt.toLowerCase() == currentVariant.option1.toLowerCase()) {

            let newSrc = ele.src.replace('.png', '_360x.png');
            newSrc = newSrc.replace('.jp', '_360x.jp');
            varMedia.push([newSrc, ele.alt]);
          } else if (ele.alt.toLowerCase() == currentVariant.option2.toLowerCase()) {
            let newSrc = ele.src.replace('.png', '_360x.png');
            newSrc = newSrc.replace('.jp', '_360x.jp');
            varMedia.push([newSrc, ele.alt]);
          }
        }
      }
    });
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#${this.dataset.form}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  renderProductInfo() {
    document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
    this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const addButton = document.getElementById(`${this.dataset.form}`)?.querySelector('[name="add"]');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', true);
      if (text) addButton.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButton.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document.getElementById(`${this.dataset.form}`)?.querySelector('[name="add"]');
    if (!addButton) return;

    addButton.textContent = window.variantStrings.unavailable;
    document.getElementById(`price-${this.dataset.product}`)?.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.dataset.json);
    return this.variantData.variants;
  }

  getProductData() {
    this.productData = this.productData || JSON.parse(this.dataset.json);
    return this.variantData;
  }
}

customElements.define('collection-variant-selects', CollectionVariantSelects);

class CollectionVariantRadios extends CollectionVariantSelects {
  constructor() {
    super();

    this.setUnavailableOption();
  }

  setUnavailableOption() {
    let productData = JSON.parse(this.dataset.json);
    let variantData = productData.variants;
    let productId = productData.id;

    for (let i = 0; i < variantData.length; i++) {
      const variant = variantData[i];
      if (!variant.available) {
        let optionInputId = 'input[id="' + productId + "-Size-" + i + '"]';
        let optionInputs = this.querySelectorAll(optionInputId);

        optionInputs.forEach(option => {
          option.classList.add('quickadd__option--unavailable');
          option.disabled = true;
        });
      }
    }
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('collection-variant-radios', CollectionVariantRadios);
